import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { SEOHead } from "../components/SEOHead";
import { getPageSeo, breadcrumbSchema } from "../seoConfig";
import { Sidebar } from "../components/Layout";
import { ContactForm, GoogleMapEmbed, CostEstimateForm } from "../components/ContactForm";
import { cleanHtml } from "../lib/seoHtml";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContentPage({ navPages }) {
  const { pageUrl, subUrl } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { const url = subUrl || pageUrl; setLoading(true); axios.get(`${API}/pages/${url}`).then(r => setPage(r.data)).catch(() => setPage(null)).finally(() => setLoading(false)); }, [pageUrl, subUrl]);
  if (loading) return <><div className="page-header"><h1>Loading...</h1></div><div className="main-layout"><div className="loading-spinner"></div><Sidebar navPages={navPages} /></div></>;
  if (!page) return <><div className="page-header"><h1>Page Not Found</h1></div><div className="main-layout"><div className="content-panel"><p>Page not found.</p></div><Sidebar navPages={navPages} /></div></>;
  const slug = subUrl || pageUrl;
  const seo = getPageSeo(slug) || {};
  const crumb = breadcrumbSchema(page.page_title || page.title, `/${slug}`);
  return (
    <div data-testid="content-page">
      <SEOHead title={seo.title || page.seo_title || page.title} description={seo.description || page.seo_desc} keywords={seo.keywords || page.seo_key} structuredData={crumb} />
      <div className="page-header"><h1>{page.page_title || page.title}</h1></div>
      <div className="main-layout"><div className="main-content"><div className="content-panel" data-testid="content-panel"><div dangerouslySetInnerHTML={{ __html: cleanHtml(page.content, { fallbackAlt: page.page_title || page.title }) }} />{seo.extra && <div className="seo-extra" data-testid="seo-extra-copy">{seo.extra.map((t, i) => <p key={i}>{t}</p>)}</div>}{page.mode === "1" && <><ContactForm /><GoogleMapEmbed /></>}{page.mode === "4" && <CostEstimateForm />}</div></div><Sidebar navPages={navPages} /></div>
    </div>
  );
}
